import React from 'react';
import { useSelector } from 'react-redux';
import { Wayfinder as Base } from '@nextiva/next-ui-wayfinder';
import { dataSelector } from '@nextiva/global-store';

const Wayfinder = ({ routeHandler, children }) => {
  const globalStoreData = useSelector(dataSelector);
  return (
    <Base globalStoreData={globalStoreData} routeHandler={routeHandler}>
      {children}
    </Base>
  );
};

export default Wayfinder;
